import axios from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const runApiChain = async ({ chainId }) => {
  const user = getUserDetails();

  const respnose = await axios.post(
    `${API_BACKEND_URL}/chains/runChain?companyId=${user.companyid}&chainId=${chainId}`,
  );
  return respnose.data;
};

export const useRunApiChain = (queryOptions) => {
  return useMutation({
    mutationFn: runApiChain,
    ...queryOptions,
  });
};
